export default __webpack_public_path__ + "static/assets/ef4bfac4e95f9cf55acc1d6a90f57cb5.png";